import * as _ from 'lodash';
import { AppInjector } from './../../app-injector';
import { ApiUrl } from './../api-url.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceProvider } from '../service.provider';
import {PreloaderService} from "../../common/services/preloader/preloader.service";
import Delivery from "../../models/Delivery";
import {catchError, map, tap} from "rxjs/operators";
import {Observable} from "rxjs/Observable";
import PaymentMethod from "../../models/PaymentMethod";
import Payment from "../../models/Payment";
import ArrayList from "../../models/ArrayList";
import Style from "../../models/Style";

@Injectable()
export class PaymentService extends ServiceProvider {

  protected url = '/api/v1/payment';

  constructor(
  ) {
    super(
      AppInjector.get(HttpClient),
      AppInjector.get(ApiUrl),
      'Payment'
    );
  }
  pay(id, data: any = {}): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + "/" + id + '/pay', data).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result =>
        new Payment(result['data'])
      ),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }
  payInBulk(data: any = []): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/pay', data).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result =>
        new ArrayList<Payment>(Payment, result['data'])
      ),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }
  //TODO super hacky shit, need to create proper service and ui for this
  listPaymentMethods(params = {}): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(`${this.url}-method/list`), JSON.stringify(params)).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      map(result => _.map((result as any).data, item => new PaymentMethod(item))),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  sendToAccountingTool(payment_id): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/' + payment_id + '/export/xero', {}).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  cancel(payment_id): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.post(this.apiUrl.getApiUrl(this.url) + '/' + payment_id + '/cancel', {}).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }

  markAsSend(payment_id, data: any = {}): Observable<any> {
    AppInjector.get(PreloaderService).show();
    return this.http.put(this.apiUrl.getApiUrl(this.url) + '/' + payment_id + '/mark-as-send', data).pipe(
      tap(result => {
        AppInjector.get(PreloaderService).hide();
      }),
      catchError(error => {
        AppInjector.get(PreloaderService).hide();
        throw error;
      })
    );
  }
}
